import { render, staticRenderFns } from "./winningRecord.vue?vue&type=template&id=586aeefe&scoped=true"
import script from "./winningRecord.vue?vue&type=script&lang=js"
export * from "./winningRecord.vue?vue&type=script&lang=js"
import style0 from "./winningRecord.vue?vue&type=style&index=0&id=586aeefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586aeefe",
  null
  
)

export default component.exports